var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconArrowSortDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 7,
    height: 12,
    viewBox: "0 0 7 12",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.89961 11.1754L2.89961 0.824585L4.09961 0.824585L4.09961 11.1754L2.89961 11.1754Z",
    fill: "#474F60"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.894531 9.04602L3.50056 11.1754L6.10658 9.04602",
    stroke: "#474F60",
    strokeWidth: 1.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowSortDown);
export default __webpack_public_path__ + "static/media/icon_arrow_sort_down.726c754d7c0eddf2cf876e6be0e0bee9.svg";
export { ForwardRef as ReactComponent };